// libraries.
import { useEffect, useContext } from 'react';
import { Marker } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import { MapContext } from '@domains/google-map/GoogleMap';

// selectors.
import {
  getSelectedCoordinates,
  getSelectedNid,
} from '../store/slices/georeferencing-slice';

export const LocationMarker = () => {
  const coordinates = useSelector(getSelectedCoordinates);
  const nid = useSelector(getSelectedNid);
  const mapContext = useContext(MapContext);

  useEffect(() => {
    if (coordinates && mapContext?.mapRef.current) {
      mapContext.mapRef.current.panTo(coordinates);

      setTimeout(() => {
        if (mapContext.mapRef.current) {
          mapContext.mapRef.current.setZoom(17);
        }
      }, 100);
    }
  }, [coordinates, mapContext]);

  if (!coordinates) {
    return null;
  }

  return (
    <Marker
      position={coordinates}
      title={`NID: ${nid}`}
      animation={google.maps.Animation.DROP}
    />
  );
};
